export { default } from './RejectedAbstract';
